import { useState } from 'react';

export function useHooks() {
  const [hover, setHover] = useState<boolean>(false);

  const toggleHover = () => setHover(!hover);

  return { hover, toggleHover };
}
